import React from 'react'
import MUIGrid from '@mui/material/Grid'

const Grid = (props) => <MUIGrid {...props} />

export default Grid
